<template>
    <Home fit="cover">
    <!-- <Home fit="contain"> -->
        <template #picture>
            <!-- background -->
            <source media="(orientation: portrait)" srcset="../assets/img/titelbild_phonePortrait.jpg">
            <source media="(orientation: landscape)" srcset="../assets/img/titelbild_phoneLandscape.jpg">
        </template>
        <template #headline><span class="text-white">Wohin mit dem Atommüll?</span></template>
        <template #subline><span class="text-white">Deutsches Endlager für eine Million Jahre gesucht </span></template>
        <template #text>
        </template>
        <template #update>
            15.04.2023
        </template>
    </Home>
</template>

<script>
    export default {
        name: 'home',
        babylonState: {
            camera: {
            position: [0.78, 0.94, 12],
            target: [0, -3, 0],
            radiusLimits: [4, 20]
            },
        },

        geo_kraftwerke: false,
        geo_teilgebiete: false,
        geo_atomendlager: {
            visible: true,
            Abfahrt: true,
            Ausschnitt: true,
            Behaelter: false,
            Behaelter_separat_1: false,
            Behaelter_separat_2: false,
            Flagge: true,
            Fuellungen: false,
            Gestein_Granit: false,
            Gestein_Salz: false,
            Gestein_Ton: false,
            Glas: false,
            Rueckwand: true,
            Schacht_001: true,
            Schacht_002: true,
            Schacht_003: true,
            Schacht_004: true,
            Stadt: true,
            System: true,
        },
        
        babylonReady: function ()
        {
           
        },
        // methods: {
        //     next: function () {
        //         this.$tracking.navigationClick('Start');
        //         this.$eventBus.$emit('nextPage');
        //     }
        // },
    }
</script>

<style lang="scss">

    .home {

        // change default opacity: 0.35
        .home__background {
            opacity: 1;
        }
        // change default object-position: unset (50% 50%)  / Für Portrait ist nur der x-Wert relevant, für Landscape nur der y-Wert. / Einheit entweder in "%" oder "px"
        .home__background img.o-fit {

            object-position: 55% 0%;
            //
            @media (orientation: landscape) {
            //
                object-position: 0% 5%;
            }
        }
    }

</style>
